import { ApolloLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import type {
  MockedProviderProps as ApolloMockedProviderProps} from '@apollo/client/testing';
import {
  MockedProvider as ApolloMockedProvider,
  MockLink,
} from '@apollo/client/testing'

export type MockedProviderProps = ApolloMockedProviderProps

const MockedProvider = ({ mocks, cache, children }: MockedProviderProps) => {
  return (
    <ApolloMockedProvider
      mocks={mocks}
      cache={cache}
      link={ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
          if (graphQLErrors) console.error('GraphQLError', graphQLErrors)
          if (networkError) console.error('NetworkError', networkError)
        }),
        new MockLink(mocks || []),
      ])}
    >
      {children}
    </ApolloMockedProvider>
  )
}

export default MockedProvider
